import { CompanySearchFilters } from '../types/CompanySearchFilters'

const companyQueryKeys = {
  all: [{ scope: 'company' }] as const,
  lists: () => [{ ...companyQueryKeys.all[0], entity: 'list' }] as const,
  list: (filters?: CompanySearchFilters) => [{ ...companyQueryKeys.lists()[0], ...filters }] as const
}

export default companyQueryKeys
